import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useWalletMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemWalletInfo */
  const menuItemWalletInfo = {
    id: "wallet-info",
    title: t("walletInfo.walletInfo"),
    url: baseRouteMaker(routes.WALLET_INFO),
  };
  tempMenuGroup.push(menuItemWalletInfo);
  /* menuItemWalletInfo */

  /* menuItemWalletTransactions */
  const menuItemWalletTransactions = {
    id: "walletTransactions",
    title: t("walletInfo.walletTransactions"),
    url: baseRouteMaker(routes.WALLET_TRANSACTION),
  };
  tempMenuGroup.push(menuItemWalletTransactions);
  /* menuItemWalletTransactions */

  /* menuItemWalletTransactions */
  const menuItemGiftCard = {
    id: "giftCard",
    title: t("walletInfo.giftCard"),
    url: baseRouteMaker(routes.GIFT_CARD),
  };
  tempMenuGroup.push(menuItemGiftCard);

  /* menuItemWalletTransactions */
  const menuItemGiftCardTransactions = {
    id: "giftCardTransactions",
    title: t("walletInfo.giftCardTransactions"),
    url: baseRouteMaker(routes.GIFT_CARD_TRANSACTIONS),
  };
  tempMenuGroup.push(menuItemGiftCardTransactions);
  /* menuItemWalletTransactions */

  return tempMenuGroup;
};
